{
    "deckActionCardDraw": {
        "cards": [
            {
                "name": "Starter_Mining_2"
            },
            {
                "name": "Starter_Mining"
            },
            {
                "name": "Starter_Fishing"
            },
            {
                "name": "Starter_Tending_2"
            }
        ]
    },
    "deckActionCardDiscard": {
        "cards": []
    },
    "deckActionDrawLeft": {
        "cards": [
            {
                "name": "Season3Action_MarketDelver"
            },
            {
                "name": "Season3Action_LakeFisher"
            },
            {
                "name": "Season3Action_FreshFarmer"
            },
            {
                "name": "Season2Action_Collector"
            },
            {
                "name": "Season2Action_CovernGrower"
            },
            {
                "name": "Season2Action_WoodCleaner"
            },
            {
                "name": "Season2Action_GeneralistMedalEarner"
            },
            {
                "name": "Season1Action_WoodScrapper"
            },
            {
                "name": "Season1Action_NoviceMiner"
            },
            {
                "name": "Season1Action_RiverDredger"
            },
            {
                "name": "Season1Action_AxeMiner"
            }
        ]
    },
    "deckActionDrawRight": {
        "cards": [
            {
                "name": "Season3Action_Geologist"
            },
            {
                "name": "Season3Action_MarketWizard"
            },
            {
                "name": "Season3Action_FishHunter"
            },
            {
                "name": "Season2Action_LureMaster"
            },
            {
                "name": "Season2Action_Excavator"
            },
            {
                "name": "Season2Action_AmateurFarmer"
            },
            {
                "name": "Season2Action_Retooler"
            },
            {
                "name": "Season1Action_NoviceForager"
            },
            {
                "name": "Season1Action_FarmMiner"
            },
            {
                "name": "Season1Action_RiverFisher"
            },
            {
                "name": "Season1Action_SocialButterfly"
            }
        ]
    },
    "deckActionCardActive": {
        "cards": [
            {
                "name": "Starter_Tending"
            },
            {
                "name": "Starter_Chopping"
            },
            {
                "name": "Starter_Fishing_2"
            },
            {
                "name": "Starter_ZenithOrders"
            },
            {
                "name": "Starter_Chopping_2"
            }
        ]
    },
    "objectiveOne": {
        "name": "Objective_S1_CentralSampler"
    },
    "objectiveTwo": {
        "name": "Objective_S2_Explorer"
    },
    "objectiveThree": {
        "name": "Objective_S3_TrueFriend"
    },
    "randomSeed": {
        "seed": 9
    }
}